'use strict'

import indexPage from './pages/index/index.page.js'

export default function ( app ) 
{
	app
		.config(function ( $routeProvider, $locationProvider ) {
	        $routeProvider
		        .otherwise(indexPage)

	        $locationProvider.html5Mode(true)
	    })
}


// WEBPACK FOOTER //
// ./src/app/routing.js